import {LOAD_FAX_DATA, DELETE_A_FAX, SAVE_A_FAX, UPDATE_A_FAX, LOAD_TOW_FAX_DATA,} from './actions';

import {
    SET_CLEAR_ALL_FILTER,
    SET_FAX_FAX_NUMBER_FILTER, SET_FAX_ENDTIME_FILTER,
    SET_FAX_PLATE_FILTER, SET_FAX_RECIPIENT_FILTER, SET_FAX_STARTTIME_FILTER,
    SET_FAX_STATUS_FILTER,
    SET_FAX_VIN_FILTER, CLEAR_A_FAX_ERROR_MESSAGE,
} from "../fax/actions";


const initialState = {
    towFaxsArray:[],
  faxsArray:[],
    deleteFaxResp:{},
    errorCMsg:{},
    saveFaxResp:{},
    updateFaxResp:{},
    faxStatusFilter:"",
    faxFaxNumberFilter:"",
    faxVinFilter:"",
    faxPlateFilter:"",
    faxRecipientNameFilter:"",
    faxStartTimeFilter:null,
    faxEndTimeFilter:null,
};




export default function reducer(state = initialState, action) {
  switch (action.type) {
      case CLEAR_A_FAX_ERROR_MESSAGE:
          return Object.assign({}, state, {
              errorCMsg: {}
          });
      case LOAD_TOW_FAX_DATA:
          return Object.assign({}, state, {
              towFaxsArray: action.towFaxsData
          });
      case LOAD_FAX_DATA:
          return Object.assign({}, state, {
              faxsArray: action.faxsData
          });
          case DELETE_A_FAX:
          return Object.assign({}, state, {
              deleteFaxResp: action.deleteFaxResponse,
              errorCMsg: action.errorMsg
          });
      case SAVE_A_FAX:
          return Object.assign({}, state, {
              saveFaxResp: action.saveFaxResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_FAX:
          return Object.assign({}, state, {
              updateFaxResp: action.updateFaxResponse,
              errorCMsg: action.errorMsg
          });
      case SET_FAX_STATUS_FILTER:
          return Object.assign({}, state, {
              faxStatusFilter: action.faxStatusFilter,
          });
      case SET_FAX_FAX_NUMBER_FILTER:
          return Object.assign({}, state, {
              faxFaxNumberFilter: action.faxFaxNumberFilter,
          });
      case SET_FAX_VIN_FILTER:
          return Object.assign({}, state, {
              faxVinFilter: action.faxVinFilter,
          });
      case SET_FAX_PLATE_FILTER:
          return Object.assign({}, state, {
              faxPlateFilter: action.faxPlateFilter,
          });
      case SET_FAX_RECIPIENT_FILTER:
          return Object.assign({}, state, {
              faxRecipientNameFilter: action.faxRecipientNameFilter,
          });
      case SET_FAX_STARTTIME_FILTER:
          return Object.assign({}, state, {
              faxStartTimeFilter: action.faxStartTimeFilter,
          });
      case SET_FAX_ENDTIME_FILTER:
          return Object.assign({}, state, {
              faxEndTimeFilter: action.faxEndTimeFilter,
          });
      case SET_CLEAR_ALL_FILTER:
          return Object.assign({}, state, {
              faxStatusFilter:"",
              faxFaxNumberFilter:"",
              faxVinFilter:"",
              faxPlateFilter:"",
              faxRecipientNameFilter:"",
              faxStartTimeFilter:null,
              faxEndTimeFilter:null,
            
          });

    default:
      return state;
  }
}
